import pantera_cap_logo_bw_circle from 'assets/investors/pantera_cap_logo-bw-circle.png'
import pantera_cap_logo_color_circle from 'assets/investors/pantera_cap_logo-color-circle.png'
import josh_hannah_bw_circle from 'assets/investors/josh_hannah-bw-circle.png'
import josh_hannah_color_circle from 'assets/investors/josh_hannah-color-circle.png'
import lemniscap_logo_bw from 'assets/investors/lemniscap_logo-bw.png'
import lemniscap_logo_color from 'assets/investors/lemniscap_logo-color.png'
import jack_herrick_bw_circle from 'assets/investors/jack_herrick-bw-circle.png'
import jack_herrick_color_circle from 'assets/investors/jack_herrick-color-circle.png'
import angeldao_logo_bw from 'assets/investors/angeldao_logo-bw.png'
import angeldao_logo_color from 'assets/investors/angeldao_logo-color.png'
import cluster_bw_circle from 'assets/investors/cluster-bw-circle.png'
import cluster_color_circle from 'assets/investors/cluster-color-circle.png'
import deepventures_bw_circle from 'assets/investors/deepventures-bw-circle.png'
import deepventures_color_circle from 'assets/investors/deepventures-color-circle.png'
import kretos_logo from 'assets/investors/kretos_logo.svg'

export const investors = {
  pantera_cap_logo_bw_circle,
  pantera_cap_logo_color_circle,
  josh_hannah_bw_circle,
  josh_hannah_color_circle,
  lemniscap_logo_bw,
  lemniscap_logo_color,
  jack_herrick_bw_circle,
  jack_herrick_color_circle,
  angeldao_logo_bw,
  angeldao_logo_color,
  cluster_bw_circle,
  cluster_color_circle,
  deepventures_bw_circle,
  deepventures_color_circle,
  kretos_logo,
}
